<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="customer_group"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="customerGroupForm"
          :redirect-detail="false"
          :show-add-button="true"
          caption="<i class='fa fa-align-justify'></i> Group Outlet Listing"
          addButton="Tambah Group Outlet"
          @editForm="editForm"
          @resetForm="resetForm"
        ></global-table>

        <b-modal
          ref="myModalRef"
          id="addModals"
          header-border-variant="no-border text-center"
          footer-border-variant="no-border"
          footer-bg-variant="light"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          size="lg"
        >
          <div slot="modal-header" class="text-center">
            <h3 class="text-center" v-if="!isEdit">Input Group Outlet Baru</h3>
            <h3 class="text-center" v-else-if="isEdit">Ubah Group Outlet</h3>
          </div>

          <b-form id="customerGroupForm" validated novalidate>
            <div v-if="!loadingSubmitModal">
              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="name" label="Nama Outlet">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="$v.customerGroupForm.name.$model"
                      :state="!$v.customerGroupForm.name.$invalid"
                      required
                      placeholder="Nama Group"
                    ></b-form-input>
                    <b-form-invalid-feedback>Nama Outlet harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="flag" label="Flag">
                    <model-select
                      id="flag"
                      :options="customer_group_flag"
                      v-model="$v.customerGroupForm.flag.$model"
                    :isError="$v.customerGroupForm.flag.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="customerGroupForm.flag === null"
                      class="invalid-feedback-custom"
                    >Flag harus di isi.</div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="flag" label="Type Group Outlet">
                    <model-select
                      id="type"
                      :options="customer_group_type"
                      v-model="$v.customerGroupForm.type.$model"
                    :isError="$v.customerGroupForm.type.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="customerGroupForm.type === null"
                      class="invalid-feedback-custom"
                    >Tipe harus di isi.</div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="pointer_color" label="Color">
                    <b-form-input
                      id="pointer_color"
                      type="text"
                      v-model="$v.customerGroupForm.pointer_color.$model"
                      :state="!$v.customerGroupForm.pointer_color.$invalid"
                      placeholder="Pointer Color"
                    ></b-form-input>
                    <b-form-invalid-feedback>Pointer Color harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6">
                  <b-form-group label-for="description" label="Deskripsi">
                    <b-form-textarea
                      id="description"
                      :rows="3"
                      :max-rows="6"
                      v-model="$v.customerGroupForm.description.$model"
                      :state="!$v.customerGroupForm.description.$invalid"
                    ></b-form-textarea>
                    <b-form-invalid-feedback>Deskripsi harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
            <div v-else>
              <loading></loading>
            </div>
          </b-form>

          <div slot="modal-footer" class="float-right">
            <div v-if="!loadingSubmitModal">
              <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
                <i class="fa fa-undo"></i> Back
              </b-button>&nbsp;
              <b-button
                type="button"
                size="sm"
                variant="primary"
                @click="saveProcess"
                :disabled="$v.customerGroupForm.$invalid"
              >
                <i class="fa fa-save"></i> Save
              </b-button>
            </div>
          </div>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import masterInterfaces from "@/templates/_master_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "customer_group",
  components: { globalTable, ModelSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      customer_group: [],
      customer_group_flag: [],
      customer_group_type: [],
      loading: true,
      loadingSubmitModal: false,
      fields: [
        { key: "name", label: "Nama Outlet", sortable: true },
        { key: "description", label: "Deskripsi" },
        { key: "flag_name", label: "Flag" },
        { key: "type_name", label: "Tipe Grup Outlet" },
        { key: "pointer_color", label: "Color" },
        { key: "action", class: "text-center width-80" }
      ],
      customerGroupForm: masterInterfaces.customer_group,
      isEdit: false
    };
  },
  validations: {
    customerGroupForm: {
      name: { required },
      flag: { required },
      type: {required},
      pointer_color: {  },
      description: {}
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function() {
      this.getCustomerGroup();
      this.getDropdownFlag();
    },
    getCustomerGroup: function() {
      this.axios
        .get("web/master/customer_group/all/")
        .then(response => {
          this.customer_group = response.data.data;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getDropdownFlag: function() {
      this.axios
        .get("web/dropdown/flag-customer-group")
        .then(response => {
          this.customer_group_flag = response.data.data;
          this.customer_group_type = response.data.group_type;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    editForm: function(e) {
      this.isEdit = true;
      this.customerGroupForm = e;
    },
    resetForm: function() {
      for (var a in masterInterfaces.customer_group) {
        masterInterfaces.customer_group[a] = null;
      }
      this.customerGroupForm = masterInterfaces.customer_group;
    },
    cancelAdd: function() {
      this.isEdit = false;
      this.$refs.myModalRef.hide();
      this.init();
    },
    saveProcess: function(evt) {
      evt.preventDefault();
      if (this.isEdit) {
        if (confirm("Apakah anda ingin mengubah group konsumen ini?")) {
          this.loadingSubmitModal = true;
          this.axios
            .put("web/master/customer_group/edit/", this.customerGroupForm)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Ubah Group Konsumen Berhasil",
                  message: response.data.message
                });
              }
            })
            .catch(error => {
              this.expired(error, 'Ubah group konsumen');
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.init();
            });
        }
      } else {
        if (confirm("Apakah anda ingin menambahkan group konsumen ini?")) {
          this.loadingSubmitModal = true;
          this.axios
            .post("web/master/customer_group/add/", this.customerGroupForm)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Tambah Group Konsumen Berhasil",
                  message: response.data.message
                });
              } else {
                this.showErrorNotification({
                  title: "Tambah Group Konsumen Gagal",
                  message: response.data.message
                });
              }
            })
            .catch(error => {
              this.expired(error, 'Tambah group konsumen');
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.init();
            });
        }
      }
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

  